<template>
  
  <div id="top">
    <Background />
    <ContentHeader class="content" />
    <div v-if="this.$vuetify.breakpoint.lgAndUp">
      <div class="hero-text-box">
      <h1 class="ml-5">
        {{ $t('home.text_box_1') }}
        <br />{{ $t('home.text_box_2') }}
      </h1>
      <router-link class="ml-5 btn btn-full mr-2 mt-2 white--text" :to="`/${$i18n.locale}/birds`">{{ $t('titels.birds') }}</router-link>
      <router-link class="ml-5 btn btn-ghost ml-2 mt-2" :to="`/${$i18n.locale}/mammal`">{{ $t('titels.mammal') }}</router-link>
    
      </div>
    </div>
    <div class="bird_count">
      <BirdCount/>
    </div>
    
    <div v-if="this.$vuetify.breakpoint.lgAndUp" class="section3">
      <Features />
    </div>
    <div v-if="this.$vuetify.breakpoint.md" class="section3-md">
      <Features />
    </div>
    <div v-if="this.$vuetify.breakpoint.sm" class="section3-sm">
      <Features />
    </div>
    <div v-if="this.$vuetify.breakpoint.xs" class="section3-xs">
      <Features />
    </div>
    
  <div v-if="this.$vuetify.breakpoint.lgAndUp">
    <div class="footer">
      <Footer />
    </div>
  </div>
  <div v-if="this.$vuetify.breakpoint.md">
    <div class="footer-md">
      <Footer />
    </div>
  </div>
  <div v-if="this.$vuetify.breakpoint.sm">
    <div class="footer-sm">
      <Footer />
    </div>
  </div>
  <div v-if="this.$vuetify.breakpoint.xs">
    <div class="footer-xs">
      <Footer />
    </div>
  </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Background from "../components/Background.vue";
//import Video from "../components/Video.vue";
import Features from "../components/Features.vue";
import Footer from "../components/Footer.vue";
import BirdCount from "../components/BirdCount";

export default {
  name: "Home",
  components: {
    ContentHeader,
    Background,
    //Video,
    Features,
    Footer,
    BirdCount
  }
};
</script>

<style>
html {
  background-color: #fff;
  color: #555;
  font-family: "Lato", "Arial", sans-serif;
  font-weight: 300;
  font-size: 20px;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
h4 {
  font-weight: 300;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  color: #fff;
  font-size: 240%;
  word-spacing: 4px;
  letter-spacing: 1px;
}

h2 {
  font-size: 180%;
  word-spacing: 2px;
  text-align: center;
  margin-bottom: 30px;
  letter-spacing: 1px;
}

h3 {
  font-size: 110%;
  margin-bottom: 15px;
}

h2:after {
  display: block;
  height: 3px;
  background-color: #2980b9;
  content: " ";
  width: 100px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 20px;
}

.content {
  width: 100%;
  height: 10%;
  position: absolute;
  top: 0%
}

.section2 {
  position: absolute;
  top: 90%;
  width: 100%;
}

.bird_count {
  position: absolute;
  width: 100%;
  top: 110%;
}

.section3 {
  position: absolute;
  width: 100%;
  top: 145%;
}
.section3-md {
  position: absolute;
  width: 100%;
  top: 145%;
}
.section3-sm {
  position: absolute;
  width: 100%;
  top: 150%;
}
.section3-xs {
  position: absolute;
  width: 100%;
  top: 170%;
}

/**************SLOGAN *******************/
.hero-text-box {
  position: absolute;
  width: 1140px;
  top: 45%;
  left: 45%;
  transform: translate(-50%, -50%);
}

.btn:link,
.btn:visited {
  display: inline-block;
  padding: 5px 20px;
  font-size: 110%;
  font-weight: 300;
  text-decoration: none;
  border-radius: 200px;
  transition: background-color 0.2s, border 0.2s, color 0.2s;
}

.btn-full:link,
.btn-full:visited {
  color: #fff;
  background-color: #2980b9;
  border: 1px solid #2980b9;
}
.btn-travel:link,
.btn-travel:visited {
  display: inline-block;
  padding: 5px 20px;
  font-size: 110%;
  font-weight: 300;
  text-decoration: none;
  transition: background-color 0.2s, border 0.2s, color 0.2s;
}

.btn-ghost:link,
.btn-ghost:visited {
  border: 1px solid #2980b9;
}

.btn:hover,
.btn:active {
  background-color: #20638f;
}

.btn-travel:hover,
.btn-travel:active {
  background-color: #20638f;
}

.btn-full:hover,
.btn-full:active {
  border: 1px solid #20638f;
}

.btn-ghost:hover,
.btn-ghost:active {
  border: 1px solid #20638f;
  color: #fff;
}
</style>
<style scoped>
.footer {
  position: absolute;
  width: 100%;
  top: 210%;
}
.footer-md {
  position: absolute;
  width: 100%;
  top: 318%;
}
.footer-sm {
  position: absolute;
  width: 100%;
  top: 360%;
}
.footer-xs {
  position: absolute;
  width: 100%;
  top: 412%;
}
</style>